import { render, staticRenderFns } from "./eventLevel.vue?vue&type=template&id=1de2fa8b&scoped=true&"
import script from "./eventLevel.vue?vue&type=script&lang=js&"
export * from "./eventLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de2fa8b",
  null
  
)

export default component.exports